import {
  mdiClose,
  mdiCircle,
  mdiSquare,
  mdiStar,
  mdiTriangle,
  mdiPlus
} from '@mdi/js';

export const defaultIcons = {
  circle: mdiCircle,
  star: mdiStar,
  triangle: mdiTriangle,
  cross: mdiPlus,
  x: mdiClose,
  square: mdiSquare
};

export const objIconsMock = [
  {
    folderName: 'mdi',
    name: 'Padrão',
    icons: ['circle', 'star', 'triangle', 'cross', 'x', 'square'],
    fillIcons: true
  },
  {
    folderName: 'acomodacao',
    name: 'Acomodação',
    icons: [
      'abrigo',
      'abrigo2',
      'cabana',
      'cama_cafe_manha',
      'camping',
      'casa',
      'hostel',
      'hotel',
      'hotel2',
      'trailer'
    ],
    fillIcons: true
  },
  {
    folderName: 'amenidades',
    name: 'Amenidades',
    icons: [
      'assento',
      'banheiro_mulher',
      'bombeiro2',
      'correio2',
      'fogo',
      'informacao',
      'policia3',
      'prisao',
      'banheiro_cadeirante',
      'banheiro',
      'bombeiro3',
      'correio',
      'fonte',
      'lixeira',
      'policia',
      'reciclagem',
      'banheiro_homem',
      'biblioteca',
      'bombeiro',
      'corte_justica',
      'hospital',
      'policia2',
      'ponto_medicao',
      'telefone'
    ],
    fillIcons: true
  },
  {
    folderName: 'comida',
    name: 'Comida',
    icons: [
      'bar',
      'cafe',
      'fastfood2',
      'fastfood',
      'pub',
      'restaurante',
      'torneira'
    ],
    fillIcons: true
  },
  {
    folderName: 'dinheiro',
    name: 'Dinheiro',
    icons: ['banco', 'caixa_eletronico2', 'caixa_eletronico', 'casa_cambio'],
    fillIcons: true
  },
  {
    folderName: 'entretenimento',
    name: 'Entretenimento',
    icons: [
      'bar',
      'cafe',
      'cinema',
      'fast_food',
      'pub',
      'restaurante',
      'teatro'
    ],
    fillIcons: true
  },
  {
    folderName: 'esporte',
    name: 'Esporte',
    icons: [
      'academia',
      'baseball',
      'cricket',
      'ginastica2',
      'hipismo',
      'mergulho',
      'parquinho',
      'sky',
      'arco_flecha',
      'centro_lazer',
      'escalada',
      'ginastica',
      'iceskating',
      'natacao_indoor',
      'sinuca',
      'tenis',
      'barco',
      'corrida',
      'futebol',
      'golf',
      'jetski',
      'natacao_outdoor',
      'sky2',
      'windsurfing'
    ],
    fillIcons: true
  },
  {
    folderName: 'flechas',
    name: 'Flechas',
    icons: [
      'flecha1',
      'flecha3',
      'flecha5',
      'seta_norte01',
      'seta_norte03',
      'seta_norte05',
      'seta_norte07',
      'seta_norte09',
      'seta_norte11',
      'flecha2',
      'flecha4',
      'flecha6',
      'seta_norte02',
      'seta_norte04',
      'seta_norte06',
      'seta_norte08',
      'seta_norte10'
    ],
    fillIcons: true
  },
  {
    folderName: 'geometrias',
    name: 'Geometrias',
    icons: [
      'brasao2',
      'brasao3',
      'brasao',
      'circulo',
      'octagono',
      'quadrado_arredondado',
      'quadrado',
      'quadrado_virado_arredondado',
      'quadrado_virado',
      'reta',
      'triangulo'
    ],
    fillIcons: true
  },
  {
    folderName: 'icones_gps',
    name: 'GPS',
    icons: [
      'ancora',
      'aviao',
      'barco',
      'carro',
      'casal',
      'cruz',
      'estacionamento',
      'interrogacao',
      'naufragio',
      'posto_abastecimento',
      'tenda',
      'animais',
      'banco',
      'camera',
      'casa1',
      'caveira',
      'dinheiro',
      'gasolina',
      'mesa',
      'paraquedas',
      'skier',
      'arvore',
      'bandeira',
      'caminhada',
      'casa2',
      'comida',
      'edificacao',
      'golf',
      'nadador',
      'peixe',
      'telefone'
    ],
    fillIcons: true
  },
  {
    folderName: 'logos',
    name: 'Logos',
    icons: [
      'osgeo-logo',
      'qgis-icon',
      'qgis-logo-made-with-color',
      'qgis-logo-made-with-monochrome',
      'qgis-logo'
    ],
    fillIcons: true
  },
  {
    folderName: 'ponto_referencia',
    name: 'Pontos de Referência',
    icons: [
      'budismo',
      'cristianismo',
      'escola',
      'hindu',
      'islamismo',
      'judaismo',
      'local_religioso',
      'museu',
      'pastafarianismo',
      'sikh'
    ],
    fillIcons: true
  },
  {
    folderName: 'religiao',
    name: 'Religião',
    icons: [
      'budismo',
      'cristianismo',
      'hindu',
      'islamismo',
      'judaismo',
      'pastafarianismo',
      'sikh'
    ],
    fillIcons: true
  },
  {
    folderName: 'rosa_dos_ventos',
    name: 'Rosa dos Ventos',
    icons: ['rosa_vento1', 'rosa_vento2'],
    fillIcons: true
  },
  {
    folderName: 'saude',
    name: 'Saúde',
    icons: [
      'dentista',
      'farmacia',
      'hospital_emergencia',
      'hospital',
      'medicos',
      'oftalmologista',
      'veterinario'
    ],
    fillIcons: true
  },
  {
    folderName: 'servicos',
    name: 'Serviços',
    icons: [
      'caixa_correio',
      'caixa_eletronico',
      'farmacia2',
      'farmacia',
      'reciclagem',
      'conveniencia',
      'supermercado',
      'telefone',
      'hotel'
    ],
    fillIcons: true
  },
  {
    folderName: 'shopping',
    name: 'Shopping',
    icons: [
      'acougue',
      'bicicleta',
      'carro',
      'conveniencia',
      'ferramentas',
      'imobiliaria1',
      'lavanderia',
      'mercado',
      'peixe',
      'pet',
      'balas_doces',
      'cabelereiro',
      'celular',
      'eletronicos',
      'floricultura',
      'imobiliaria2',
      'livro',
      'motos',
      'pescaria',
      'presentes',
      'bebidas_alcoolicas',
      'carro_reparo',
      'confeitaria',
      'feira',
      'fotos',
      'joalheria',
      'locadoura',
      'musica',
      'pet2',
      'roupas'
    ],
    fillIcons: true
  },
  {
    folderName: 'simbolos',
    name: 'Símbolos',
    icons: [
      'acessibilidade2',
      'arvore2',
      'bunker_militar',
      'embaixada2',
      'fonte',
      'marcador_azul',
      'morros',
      'placa2',
      'placa',
      'ponto_interesse',
      'universidade',
      'acessibilidade',
      'arvores',
      'caverna',
      'embaixada',
      'gramado',
      'marcador_vermelho',
      'pantano',
      'placa3',
      'poi_tower_power',
      'torre_comunicacao',
      'arvore1',
      'bercario',
      'cego',
      'escola',
      'gramineas',
      'mineracao',
      'pedreira',
      'placa4',
      'poi_tower_water',
      'torre_dagua'
    ],
    fillIcons: true
  },
  {
    folderName: 'sinais_advertencia_dnit',
    name: 'Sinais de Advertência',
    icons: [
      'Brasil_A-10a',
      'Brasil_A-13b',
      'Brasil_A-19',
      'Brasil_A-21b',
      'Brasil_A-24',
      'Brasil_A-29',
      'Brasil_A-31',
      'Brasil_A-35',
      'Brasil_A-3b',
      'Brasil_A-43',
      'Brasil_A-4a',
      'Brasil_A-7b',
      'Brasil_A-10b',
      'Brasil_A-14',
      'Brasil_A-1a',
      'Brasil_A-21c',
      'Brasil_A-25',
      'Brasil_A-2a',
      'Brasil_A-32a',
      'Brasil_A-36',
      'Brasil_A-40',
      'Brasil_A-44',
      'Brasil_A-4b',
      'Brasil_A-8',
      'Brasil_A-11a',
      'Brasil_A-15',
      'Brasil_A-1b',
      'Brasil_A-21d',
      'Brasil_A-26a',
      'Brasil_A-2b',
      'Brasil_A-32b',
      'Brasil_A-37',
      'Brasil_A-41b',
      'Brasil_A-45',
      'Brasil_A-5a',
      'Brasil_A-9',
      'Brasil_A-11b',
      'Brasil_A-16',
      'Brasil_A-20a',
      'Brasil_A-21e',
      'Brasil_A-26b',
      'Brasil_A-30a',
      'Brasil_A-33a',
      'Brasil_A-38',
      'Brasil_A-42a',
      'Brasil_A-46',
      'Brasil_A-5b',
      'Brasil_A-12',
      'Brasil_A-17',
      'Brasil_A-20b',
      'Brasil_A-22',
      'Brasil_A-27',
      'Brasil_A-30b',
      'Brasil_A-33b',
      'Brasil_A-39',
      'Brasil_A-42b',
      'Brasil_A-47',
      'Brasil_A-6',
      'Brasil_A-13a',
      'Brasil_A-18',
      'Brasil_A-21a',
      'Brasil_A-23',
      'Brasil_A-28',
      'Brasil_A-30c',
      'Brasil_A-34',
      'Brasil_A-3a',
      'Brasil_A-42c',
      'Brasil_A-48',
      'Brasil_A-7a'
    ],
    fillIcons: false
  },
  {
    folderName: 'sinais_regulamentacao_dnit',
    name: 'Sinais de Regulamentação',
    icons: [
      'Brasil_R-10',
      'Brasil_R-15',
      'Brasil_R-1',
      'Brasil_R-24a',
      'Brasil_R-25d',
      'Brasil_R-2',
      'Brasil_R-34',
      'Brasil_R-37',
      'Brasil_R-4a',
      'Brasil_R-6b',
      'Brasil_R-9',
      'Brasil_R-11',
      'Brasil_R-16',
      'Brasil_R-20',
      'Brasil_R-24b',
      'Brasil_R-26',
      'Brasil_R-30',
      'Brasil_R-35a',
      'Brasil_R-38',
      'Brasil_R-4b',
      'Brasil_R-6c',
      'Brasil_R-12',
      'Brasil_R-17',
      'Brasil_R-21',
      'Brasil_R-25a',
      'Brasil_R-27',
      'Brasil_R-31',
      'Brasil_R-35b',
      'Brasil_R-39',
      'Brasil_R-5a',
      'Brasil_R-7',
      'Brasil_R-13',
      'Brasil_R-18',
      'Brasil_R-22',
      'Brasil_R-25b',
      'Brasil_R-28',
      'Brasil_R-32',
      'Brasil_R-36a',
      'Brasil_R-3',
      'Brasil_R-5b',
      'Brasil_R-8a',
      'Brasil_R-14',
      'Brasil_R-19',
      'Brasil_R-23',
      'Brasil_R-25c',
      'Brasil_R-29',
      'Brasil_R-33',
      'Brasil_R-36b',
      'Brasil_R-40',
      'Brasil_R-6a',
      'Brasil_R-8b',
      'Brasil_R-19_(10)',
      'Brasil_R-19_(20)',
      'Brasil_R-19_(30)',
      'Brasil_R-19_(40)',
      'Brasil_R-19_(50)',
      'Brasil_R-19_(60)',
      'Brasil_R-19_(70)',
      'Brasil_R-19_(80)',
      'Brasil_R-19_(90)',
      'Brasil_R-19_(100)',
      'Brasil_R-19_(110)',
      'Brasil_R-19_(120)',
      'Brasil_R-19_(130)',
      'Brasil_R-19_(140)'
    ],
    fillIcons: false
  },
  {
    folderName: 'transporte',
    name: 'Transporte',
    icons: [
      'aerodrome2',
      'aeroporto',
      'barreira2',
      'estacao_trem2',
      'farol',
      'parada_onibus3',
      'porto',
      'taxi2',
      'travessia_rio',
      'aerodromo1',
      'aluguel_bicicleta',
      'barreira3',
      'estacao_trem3',
      'gasolina',
      'parada_onibus4',
      'rotatoria_antihorario',
      'taxi',
      'aeroporto1',
      'aluguel_carro',
      'barreira4',
      'estacao_trem4',
      'marina',
      'parada_onibus',
      'rotatoria_horario',
      'terminal_portuario',
      'aeroporto2',
      'barreira1',
      'barreira',
      'estacao_trem',
      'parada_onibus2',
      'pedagio',
      'semaforo',
      'transporte_compartilhado'
    ],
    fillIcons: true
  },
  {
    folderName: 'turismo',
    name: 'Turismo',
    icons: [
      'arqueologia1',
      'campo_batalha',
      'castelo',
      'cinema',
      'fonte',
      'galeria_arte2',
      'moinho_de_vento',
      'museu',
      'observatorio',
      'praia',
      'ruina',
      'trem_a_vapor',
      'arqueologia2',
      'casino',
      'cinema2',
      'fonte2',
      'galeria_arte1',
      'memorial',
      'monumento',
      'naufragio',
      'picnic',
      'roda_dagua',
      'teatro',
      'zoo'
    ],
    fillIcons: true
  },
  {
    folderName: 'turismo_2',
    name: 'Turismo 2',
    icons: [
		'bicycle-share',
		'bus',
		'calendar-days',
		'car-rental',
		'college',
		'dollar-sign',
		'fuel',
		'hospital',
		'industry',
		'information',
		'lodging',
		'museum',
		'natural',
		'police',
		'ranger-station',
		'religious-christian',
		'restaurant',
		'road',
		'rocket',
		'sack-dollar',
		'shop',
		'signs-post',
		'soccer',
		'telephone',
		'theatre',
		'train'
    ],
    fillIcons: true
  }
];
